import React from "react";
import { Button } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import { useForm } from "react-hook-form";
import { useMutation } from "react-query";
import { toast, ToastContainer } from "react-toastify";

import { useAdminUpadteWithdraw } from "../../hooks/useAdminUpdateWithdraw";

function AdminUpdateWithdrawRequest(props) {
  const {
    formState: { errors },
    handleSubmit,
  } = useForm({
    defaultValues: {},
  });

  const { mutate, isLoading } = useMutation(useAdminUpadteWithdraw, {
    onSuccess: (data) => {
      notifySuccess();
      props.refetch().then(() => {});
      props.onHide();
    },
    onError: (error) => {
      notifyError(error?.response.data.error);
    },
  });
  const notifyError = (error) => toast.error(error);
  const notifySuccess = () =>
    toast.success("Withdraw request succesfull updated");
  const onSubmit = (data) => {
    const requestData = {
      id: props.data.id, // Replace "asdasda" with the actual value you want for id
      status: props.status, // Replace "your_status_value" with the actual status you want to send
    };
    mutate(requestData);
  };
  function formatCreatedAt(createdAt) {
    const date = new Date(createdAt);
    const formattedDate = date.toLocaleDateString(); // Change toLocaleDateString to other format if needed
    return formattedDate;
  }

  return (
    <div>
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <form onSubmit={handleSubmit(onSubmit)}>
          <Modal.Header closeButton>
            <Modal.Title>Confirm update</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {props?.data && (
              <>
                Are you sure you want to update the withdraw request created at{" "}
                <strong>{formatCreatedAt(props.data.created_at)} </strong>
                and amount <strong>{props.data.amount}</strong> as{" "}
                {props.status}?
              </>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={props.onHide}>
              Close
            </Button>
            <Button
              type={"submit"}
              size="sm"
              variant="carre-blue w-25"
              disabled={isLoading}
            >
              {!isLoading ? "Update Request" : "Please wait"}
            </Button>
          </Modal.Footer>
        </form>
      </Modal>
    </div>
  );
}

export default AdminUpdateWithdrawRequest;
